import { render, staticRenderFns } from "./voucherRetirado.vue?vue&type=template&id=079d46c2"
import script from "./voucherRetirado.vue?vue&type=script&lang=js"
export * from "./voucherRetirado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports